import { render, staticRenderFns } from "./NewEmployee.vue?vue&type=template&id=813c5d20&scoped=true&"
import script from "./NewEmployee.vue?vue&type=script&lang=js&"
export * from "./NewEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813c5d20",
  null
  
)

export default component.exports